import { FormType } from "../schemas";

export const mapFinalData = (props: {
    originalData: FormType["detail"]
    currentDetail: FormType
}) => {

    const changedDetail = props.currentDetail.detail?.map((item, index) => {
        const originalItem = props.originalData?.[index];

        const isItemChanged =
            item.employee_id !== originalItem?.employee_id ||
            item.location_id !== originalItem?.location_id;

        const changedShifts = item.shift_schedule?.filter((shift, sIndex) => {
            const originalShift = originalItem?.shift_schedule?.[sIndex];

            if (!shift?.mr_shift_id && !originalShift?.mr_shift_id) return false;

            return (
                shift.mr_shift_id !== originalShift?.mr_shift_id ||
                shift.in_time !== originalShift?.in_time ||
                shift.out_time !== originalShift?.out_time
            );
        });

        if ((changedShifts?.length ?? 0) > 0 || isItemChanged) {
            return {
                ...item,
                shift_schedule: changedShifts,
            };
        }

        return null;
    }).filter(Boolean);





    return changedDetail
} 


export const mapDataSubmitSingle = ({
    rowData, 
    start_date,
    end_date
}: {
    rowData: any, 
    start_date: string,
    end_date: string
}) => {
    const mapData = {
            shift_schedule: {
                periode_start: start_date,
                periode_end: end_date,
                shift_schedule_id: rowData.shift_schedule_id
            },
            shift_schedule_detail: rowData.shift_schedule?.map((shift: any) => ({
                shift_schedule_id: Number(rowData.shift_schedule_id) ?? null,
                employee_id: Number(rowData.employee_id),
                job_position_id: Number(rowData.job_position_id),
                divisi_id: rowData.divisi_id ? Number(rowData.divisi_id) : null,
                department_id: Number(rowData.department_id),
                location_id: Number(rowData.location_id) || 0,
                date_shift: shift.shift_date,
                mr_shift_id: shift.mr_shift_id ? Number(shift.mr_shift_id) : null,
                in_time: shift.in_time ?? "",
                out_time: shift.out_time ?? "",
                shift_schedule_detail_id: Number(shift.shift_schedule_detail_id)
            }))
        };

    return mapData
}